import dayjs from "dayjs";
import dayjsBusinessTime from "dayjs-business-time";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/nb";
import "dayjs/locale/nl";
import "dayjs/locale/fr";
import "dayjs/locale/en";

// Singleton
export default class DayJs {
    private static instance: DayJs;
    public dayjs: typeof dayjs;

    public static getInstance(): typeof dayjs {
        if (!DayJs.instance) {
            DayJs.instance = new DayJs();
            DayJs.instance.dayjs = dayjs;
            DayJs.instance.dayjs.locale(window.wordpress_locale.substring(0, 2));
            DayJs.instance.dayjs.extend(dayjsBusinessTime);
            DayJs.instance.dayjs.extend(relativeTime);
        }

        return DayJs.instance.dayjs;
    }
}
